// extracted by mini-css-extract-plugin
module.exports = {"container":"app_container__hJ3Lb","main":"app_main__v0uSm","footer":"app_footer__RxdZG"};